import { render, staticRenderFns } from "./ViewSettingsClients.vue?vue&type=template&id=61fc883d&scoped=true&"
import script from "./ViewSettingsClients.vue?vue&type=script&lang=js&"
export * from "./ViewSettingsClients.vue?vue&type=script&lang=js&"
import style0 from "./ViewSettingsClients.vue?vue&type=style&index=0&id=61fc883d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fc883d",
  null
  
)

export default component.exports